/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_CommonholdInputs */

const en_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commonhold`)
};

const es_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Propiedad compartida`)
};

const fr_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copropriété`)
};

const de_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wohneigentum`)
};

const ja_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`区分所有権`)
};

const zh_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公共产权`)
};

const ar_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملكية مشتركة`)
};

const id_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hak Bersama (Commonhold)`)
};

const it_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proprietà Condivisa`)
};

const ru_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Совместное владение`)
};

const pt_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Condomínio`)
};

const ko_val_commonhold = /** @type {(inputs: Val_CommonholdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`구분 소유권 (Commonhold)`)
};

/**
* | output |
* | --- |
* | "Commonhold" |
*
* @param {Val_CommonholdInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_commonhold = /** @type {((inputs?: Val_CommonholdInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_CommonholdInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_commonhold(inputs)
	if (locale === "es") return es_val_commonhold(inputs)
	if (locale === "fr") return fr_val_commonhold(inputs)
	if (locale === "de") return de_val_commonhold(inputs)
	if (locale === "ja") return ja_val_commonhold(inputs)
	if (locale === "zh") return zh_val_commonhold(inputs)
	if (locale === "ar") return ar_val_commonhold(inputs)
	if (locale === "id") return id_val_commonhold(inputs)
	if (locale === "it") return it_val_commonhold(inputs)
	if (locale === "ru") return ru_val_commonhold(inputs)
	if (locale === "pt") return pt_val_commonhold(inputs)
	return ko_val_commonhold(inputs)
});